import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "label", "empty"]

  connect() {
    this.boundHandler = (e) => this.applyFilter(e.detail.slugs)
    window.addEventListener("map:viewport-changed", this.boundHandler)
  }

  disconnect() {
    window.removeEventListener("map:viewport-changed", this.boundHandler)
  }

  applyFilter(slugs) {
    const visible = new Set(slugs || [])
    const cards = this.element.querySelectorAll("[data-school-slug]")
    if (cards.length === 0) return

    let visibleCount = 0
    cards.forEach(card => {
      const slug = card.dataset.schoolSlug
      const inView = !slug || visible.has(slug)
      card.style.display = inView ? "" : "none"
      if (inView) visibleCount++
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = visibleCount
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = visibleCount === 1 ? "rijschool in beeld" : "rijscholen in beeld"
    }
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }
}
